import { BarDataUtil, CommonDataUtil } from '../../data-mapper/utils';
import { IHighChartsAttributesModel } from '../../models/high-charts-attributes.interface';
import { BaseChartWorker } from '../common/base-chart.worker';


/**
 * BarChartWorker: chart worker specific to a Bar Chart.
 * @param {any} config JSON object representing the chart configuration.
 * @param {IHighChartsAttributesModel} highChartsAttributes an object containing properties used to augment the chart configuration.
 */
export class BarChartWorker extends BaseChartWorker {
	constructor(config: any, highChartsAttributes: IHighChartsAttributesModel) {
		super(config, highChartsAttributes);
		if (!this.highChartsAttributes.isPdf) {
			this.initChartForWeb();
		}
	}

	private initChartForWeb(): void {
		let marginTop: number = 0;
		let spacingBottom: number = 15;
		const sibling: any =
			this.highChartsAttributes.container &&
			this.highChartsAttributes.container.nativeElement.parentElement &&
			(this.highChartsAttributes.container.nativeElement.parentElement.previousElementSibling ||
				this.highChartsAttributes.container.nativeElement.parentElement.nextElementSibling);
		if (sibling && sibling.tagName.toLowerCase() === 'dl-display-table') {
			marginTop = sibling.querySelector('header').offsetHeight - 1;
			spacingBottom = -8;
		}
		this.config.chart.marginTop = marginTop;
		this.config.chart.marginBottom = spacingBottom;
		this.config.legend.y = -this.highChartsAttributes.height - spacingBottom + marginTop;
	}


	public transformData(): void {
		const seriesColors = this.highChartsAttributes.colors ? this.highChartsAttributes.colors : CommonDataUtil.getPortfolioColors();
		const seriesCategories = CommonDataUtil.getCategoriesForTabData(this.highChartsAttributes.tabData);
		const seriesData = BarDataUtil.getDefaultBarSeriesForTabData(this.highChartsAttributes.tabData);
		this.config.colors = seriesColors;
		this.config.series = seriesData;
		this.config.xAxis.categories = seriesCategories;
	}
}
